import { Box, Stack } from "@mui/material";

import {
  EVOTRUX_BLUE_DARK,
  EVOTRUX_BLUE_LIGHT,
  LIGHT_GREY,
} from "constants/index";

import { NOTIFICATION_FILTER_OPTIONS } from "./utils";

import type { NotificationFilter } from "./types";

interface NotificationFilterLabelProps {
  option: NotificationFilter;
  count: number;
  isActive: boolean;
}

export function NotificationFilterLabel(props: NotificationFilterLabelProps) {
  const { option, count, isActive } = props;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <span>{NOTIFICATION_FILTER_OPTIONS[option].label}</span>
      <Box
        component="span"
        sx={{
          px: 1,
          minWidth: "1.5rem",
          borderRadius: "10px",
          fontSize: "12px",
          lineHeight: "20px",
          textAlign: "center",
          backgroundColor: isActive ? EVOTRUX_BLUE_LIGHT : LIGHT_GREY,
          color: isActive ? EVOTRUX_BLUE_DARK : "text.primary",
        }}
      >
        {count}
      </Box>
    </Stack>
  );
}
